"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1587))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.646Z
 */
export const Malta = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2H9V14H1V2Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4H4V5.496C3.88763 5.52273 3.78798 5.58753 3.71798 5.67941C3.64797 5.77129 3.61194 5.88457 3.616 6H2V8H3.665C3.73 8.1335 3.8525 8.234 4 8.2695V10H6V8.2755C6.07864 8.26214 6.15293 8.23016 6.21669 8.18224C6.28045 8.13431 6.33181 8.07183 6.3665 8H8V6H6.4155V5.983C6.41555 5.86501 6.37386 5.75081 6.29782 5.66058C6.22179 5.57036 6.11629 5.50994 6 5.49V4Z"
      fill="#A0A0A0"
    />
    <mask
      id="mask0_8944_1587"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="4"
      width="6"
      height="6"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4H4V5.496C3.88763 5.52273 3.78798 5.58753 3.71798 5.67941C3.64797 5.77129 3.61194 5.88457 3.616 6H2V8H3.665C3.73 8.1335 3.8525 8.234 4 8.2695V10H6V8.2755C6.07864 8.26214 6.15293 8.23016 6.21669 8.18224C6.28045 8.13431 6.33181 8.07183 6.3665 8H8V6H6.4155V5.983C6.41555 5.86501 6.37386 5.75081 6.29782 5.66058C6.22179 5.57036 6.11629 5.50994 6 5.49V4Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_8944_1587)">
      <path
        d="M4 4V3.5H3.5V4H4ZM6 4H6.5V3.5H6V4ZM4 5.496L4.115 5.9825L4.5 5.8915V5.4965H4V5.496ZM3.616 6V6.5H4.1335L4.116 5.983L3.616 6ZM2 6V5.5H1.5V6H2ZM2 8H1.5V8.5H2V8ZM3.665 8L4.1155 7.7825L3.979 7.5H3.6655L3.665 8ZM4 8.2695H4.5V7.874L4.115 7.783L4 8.2695ZM4 10H3.5V10.5H4V10ZM6 10V10.5H6.5V10H6ZM6 8.2755L5.9165 7.783L5.5 7.853V8.2755H6ZM6.3665 8V7.5H6.0525L5.916 7.7825L6.3665 8ZM8 8V8.5H8.5V8H8ZM8 6H8.5V5.5H8V6ZM6.4155 6L5.9155 5.983L5.899 6.5H6.416L6.4155 6ZM6 5.49H5.5V5.912L5.9165 5.983L6 5.49ZM4 4.5H6V3.5H4V4.5ZM4.5 5.496V4H3.5V5.496H4.5ZM4.116 5.983L4.115 5.9825L3.884 5.01C3.66512 5.06209 3.4702 5.18646 3.33075 5.36302C3.1913 5.53958 3.11546 5.75801 3.1155 5.983H4.116ZM4.116 5.983H3.1155L3.116 6.017L4.116 5.983ZM2 6.5H3.616V5.5H2V6.5ZM2.5 8V6H1.5V8H2.5ZM3.6655 7.5H2V8.5H3.665L3.6655 7.5ZM4.115 7.783L4.1155 7.7825L3.2155 8.2175C3.28001 8.35131 3.37353 8.46908 3.48925 8.56222C3.60497 8.65537 3.73999 8.72157 3.8845 8.756L4.115 7.783ZM4.5 10V8.2695H3.5V10H4.5ZM6 9.5H4V10.5H6V9.5ZM5.5 8.2755V10H6.5V8.2755H5.5ZM6.0835 8.7685C6.4085 8.7135 6.6785 8.503 6.8165 8.2175L5.9165 7.7825L6.0835 8.7685ZM8 7.5H6.3665V8.5H8V7.5ZM7.5 6V8H8.5V6H7.5ZM6.416 6.5H8V5.5H6.4155L6.416 6.5ZM5.9155 5.983L6.9155 6.017V5.983H5.9155ZM5.9165 5.983C5.915 5.983 5.915 5.982 5.9155 5.983C5.9155 5.982 5.9155 5.982 5.9155 5.983H6.9155C6.91553 5.7468 6.83245 5.51822 6.68008 5.33775C6.5277 5.15727 6.31636 5.03656 6.0835 4.997L5.9165 5.983ZM5.5 4V5.49H6.5V4H5.5Z"
        fill="#FECA00"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2H17V14H9V2Z"
      fill="#E31D1C"
    />
    <rect x="1" y="2" width="16" height="12" stroke="#757575" />
  </>,
  "Malta",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
